import { formatCouverturePath, handleAnchor } from '../../libs/apiController';
import '../../utils/style/serierighttips.css';

function SerieRightNavigation({ serieContent, isWishlist = false, currentAlbumId = null }) {

    const maxLengthAlbums = 16
    const widthCouvCarouselInt = serieContent?.length > maxLengthAlbums ? 5 : 7
    const heightCouvCarouselInt = Math.round(widthCouvCarouselInt * 1.41)
    const widthCouvCarousel = widthCouvCarouselInt.toString() + 'vmin'
    const heightCouvCarousel = heightCouvCarouselInt.toString() + 'vmin'

    // Badge tome (bas-gauche) : rien si l'album n'a pas de numéro (one shot)
    const tomeBadgeClass = `tipsRightImageBg tipsRightImageBL ${serieContent?.length > maxLengthAlbums ? 'text-petit-bold' : 'text-moyen-bold'}`
    const renderTomeBadge = (album) => (album.tome ?? '') !== '' && (
        <p className={tomeBadgeClass}>{album.tome}</p>
    )

    // Numérotation auto des cycles : 1er album avec finDeCycle = cycle 1, etc.
    // (l'ordre suit serieContent, déjà trié par tome côté backend)
    const cycleIndexByAlbumId = {}
    let cycleCount = 0
    serieContent?.forEach((album) => {
        if (album?.finDeCycle) {
            cycleCount++
            cycleIndexByAlbumId[album._id] = cycleCount
        }
    })

    return (
        <div>
            { serieContent?.length > 0  &&
                <div className="tipsRightContainer">

                    <div className='tipsRightContent'>
                            {serieContent?.map((album, index) => { const isActive = String(album._id) === String(currentAlbumId); return ( album &&
                                <div className={`tipsRightImage${isActive ? ' is-active' : ''}`} key={`${album._id}-${index}`}>

                                    {(!isWishlist && album.finDeCycle) ?
                                    (<span onClick={() => handleAnchor(album._id)} title={`Fin du ${cycleIndexByAlbumId[album._id]}${cycleIndexByAlbumId[album._id] === 1 ? 'er' : 'ème'} cycle`}>
                                        <div className={`infoNavSerie${isActive ? ' is-active' : ''}`}>
                                            <img alt="couv" className='infoNavSerie-couv' src={formatCouverturePath(album)} style= {{'opacity': '0.6', 'height': heightCouvCarousel, 'width' : widthCouvCarousel}}/>
                                            <img alt="overlay" className='infoNavSerie-overlay' src={'/assets/findecycle.png'} style= {{'height': heightCouvCarousel, 'width' : widthCouvCarousel}} />
                                            {renderTomeBadge(album)}
                                        </div>
                                    </span>
                                    )
                                    :
                                    (
                                    <span onClick={() => handleAnchor(album._id)}>
                                        <img src={formatCouverturePath(album)} 
                                            style= {{'height': heightCouvCarousel, 'width' : widthCouvCarousel}}
                                            alt={album.tome}
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null; // prevents looping
                                                currentTarget.src=formatCouverturePath(album); // permet de reload l'image après le premier 404
                                            }}
                                        />
                                        {renderTomeBadge(album)}
                                    </span>
                                    )
                                    }
                                    
                                </div>
                            )})}
                    </div>

                </div>
            }
        </div>
    )
}

export default SerieRightNavigation;